import type { CreateFeedbackRequest } from '@xpanse/ui';

import { useMutation } from '@tanstack/react-query';

import { FeedbackService } from 'src/utils/services';

export async function postFeedback(runId: string, payload: CreateFeedbackRequest) {
  const response = await FeedbackService.createFeedback(runId, payload);

  return response;
}

export function useSubmitFeedback() {
  const { mutate: submitFeedback } = useMutation({
    mutationFn: ({ runId, payload }: { runId: string; payload: CreateFeedbackRequest }) =>
      postFeedback(runId, payload),
  });

  return {
    submitFeedback,
  };
}
